import SearchFullscreen from './SearchFullscreenContainer';

export default SearchFullscreen;



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/index.js